// All regex expression can add in this file

/* Phone format with prefix zero number */
const phonePrefixZero = /^0?[1-9][0-9]{6,14}|$/

/* Cannot contain white space and special character */
const noWhiteSpaceAndSpecialChar = /^[a-zA-Z0-9]+|$/

/* Cannot use space prefix */
const notPrefixSpace = /^(?!\s+|$)/
const notPrefixSuffixSpace = /^[^\s].+[^\s]$/
// const notPrefixSpace = /^\S.*[a-zA-Z0-9\s]*$/

/* Cannot use space character */
const notSpaceChar = /^\S*$/

/* Cannot use space as the first character */
const notSpaceInFirstChar = /^\S.*[a-zA-Z0-9\s]*|$/

/* Cannot contain white space and special character except dash or underscore  */
const notOnlySpecialChar = /^[A-Za-z0-9_-]+$/

/* Cannot contain special character */
const noSpecialChar = /^[A-Za-z0-9\s]+$/

// Cannot use special char, and number. Just alphabet and space
const nameJustAlphabetAndSpace = /^[A-Za-z\s]+$/

const employeeCode = /^[A-Za-z0-9-]+$/

/* KTP 16 Digit */
const KTP = /^(1[1-9]|21|[37][1-6]|5[1-3]|6[1-5]|[89][12])\d{2}\d{2}([04][1-9]|[1256][0-9]|[37][01])(0[1-9]|1[0-2])\d{2}\d{4}$/

const KK = /^[0-9]{16}$/

const SIM = /^[0-9]{14}$/

const BPJS = /^[0-9]{13}$/

const phoneNumber = /^8[1-9][0-9]{6,9}$/

const numberOnly = /^[0-9]+$/

const nfcTag = /^[0-9]+$/

const imageFile = /\.(jpe?g|png)$/i

const rgxExp = {
  phonePrefixZero,
  noWhiteSpaceAndSpecialChar,
  notPrefixSpace,
  notSpaceChar,
  notSpaceInFirstChar,
  KTP,
  KK,
  SIM,
  BPJS,
  phoneNumber,
  nfcTag,
  nameJustAlphabetAndSpace,
  notPrefixSuffixSpace,
  notOnlySpecialChar,
  noSpecialChar,
  employeeCode,
  numberOnly,
  imageFile
}

export default rgxExp
